module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showOver) ? _c('gameOver', {
    attrs: {
      "score": _vm.gameScore,
      "gameFlag": _vm.gameType,
      "tempFlag": 1
    },
    on: {
      "restart": _vm.restartTrain,
      "close": _vm.closeGame
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showDialog,
      "dialogClass": "diaTrainContent"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "height": "320px"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "40"
    }
  }, [_c('mu-paper', {
    staticStyle: {
      "width": "240px",
      "height": "240px"
    },
    attrs: {
      "zDepth": 1
    }
  }, [_c('img', {
    staticStyle: {
      "width": "240px",
      "height": "240px"
    },
    attrs: {
      "src": _vm.address + _vm.game.image
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold-content",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.game.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.game.label_desc), function(item) {
    return _c('span', {
      staticStyle: {
        "font-size": "14px",
        "padding-top": "20px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(item.name) + "  ")])
  })], 2)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "60"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticStyle: {
      "height": "286px"
    }
  }, [_c('mu-row', [_c('mu-col')], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "canWidth"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticStyle: {
      "height": "70px"
    }
  }, [(_vm.game.desc != '康复1.0言语游戏移植') ? _c('span', {
    staticClass: "title-style"
  }, [_vm._v("游戏介绍")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.game.desc == '康复1.0言语游戏移植') ? _c('span', {
    staticClass: "desc-content"
  }, [_vm._v(" ")]) : _c('span', {
    staticClass: "desc-content",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.game.desc))])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-row', [_c('mu-col', [_c('div', [_c('span', {
    staticClass: "title-style"
  }, [_vm._v("脑能力介绍")]), _c('br'), _vm._v(" "), _vm._l((_vm.game.label_desc), function(item) {
    return _c('span', {
      staticClass: "desc-content",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(item.name) + "：" + _vm._s(item.desc)), _c('br')])
  })], 2)])], 1)], 1), _vm._v(" "), _c('mu-col', [_c('div', [(_vm.saveGame) ? _c('trainCronSave', {
    attrs: {
      "gameData": _vm.game,
      "gameFlag": _vm.gameFlag,
      "caseId": _vm.$parent.caseId,
      "caseName": _vm.$parent.caseName,
      "todayGames": _vm.todayGames
    },
    on: {
      "restart": _vm.restartLanTrain,
      "updateScore": _vm.getGameScore,
      "close": function($event) {
        _vm.saveGame = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showVerbal) ? _c('verbalGames', {
    ref: "verbalM",
    attrs: {
      "gameData": _vm.game
    },
    on: {
      "verbalEvent": _vm.verbalFun
    }
  }) : _vm._e()], 1)])], 1)], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-right": "26px"
    },
    attrs: {
      "slot": "actions",
      "label": "取消"
    },
    on: {
      "click": _vm.cancelGame
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-left": "24px",
      "margin-right": "30px"
    },
    attrs: {
      "slot": "actions",
      "label": "30秒体验",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.openGame(0)
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c18d87a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/train/lanTrainIntroduction.vue
// module id = 947
// module chunks = 2